import React from "react";
import PropTypes from "prop-types";
import { Box, Tab, Tabs, Chip, useTheme, alpha } from "@mui/material";
import AddProduct from "./components/addProduct/AddProduct";
import Support from "./components/suport/Support";
import CommunityComp from "./components/community/CommunityComp";
import Profile from "./components/profile/Profile";
import { ShoppingBag, SupportAgent, People, Lock } from "@mui/icons-material";

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            animation: "fadeIn 0.4s ease-in-out",
            "@keyframes fadeIn": {
              from: { opacity: 0, transform: "translateY(10px)" },
              to: { opacity: 1, transform: "translateY(0)" },
            },
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const TabsComp = ({ data, value, setValue, handleChange }) => {
  const theme = useTheme();

  const tabs = [
    { label: data.myPurchase, icon: <ShoppingBag /> },
    { label: data.support, icon: <SupportAgent /> },
    { label: data.community, icon: <People /> },
    { label: data.changePass, icon: <Lock /> },
  ];

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 4,
        overflow: "hidden",
        boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, 0.05)}`,
      }}
    >
      {/* Tab Header */}
      <Box
        sx={{
          borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          px: { xs: 1, sm: 2 },
          background:
            theme.palette.mode === "dark"
              ? `linear-gradient(135deg, ${alpha(
                  theme.palette.background.paper,
                  0.8,
                )}, ${alpha(theme.palette.background.default, 0.8)})`
              : `linear-gradient(135deg, ${alpha(
                  theme.palette.primary.light,
                  0.03,
                )}, ${alpha(theme.palette.secondary.light, 0.02)})`,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="navigation tabs"
          TabIndicatorProps={{
            style: {
              height: 3,
              borderRadius: "3px 3px 0 0",
              background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            },
          }}
          sx={{
            "& .MuiTab-root": {
              minHeight: 64,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.95rem",
              color: "text.secondary",
              transition: "all 0.3s ease",
              "&:hover": {
                color: "primary.main",
                bgcolor: alpha(theme.palette.primary.main, 0.05),
              },
              "&.Mui-selected": {
                color: "primary.main",
              },
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
      </Box>

      {/* Tab Content */}
      <CustomTabPanel value={value} index={0}>
        <AddProduct setValue={setValue} data={data} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Support data={data} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <CommunityComp data={data} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Profile data={data} />
      </CustomTabPanel>
    </Box>
  );
};

TabsComp.propTypes = {
  data: PropTypes.object.isRequired,
  value: PropTypes.number.isRequired,
  setValue: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default TabsComp;
